import graphqlClient from '~/graphql/graphqlClient';

export interface MutationUpgradeAbilityArgs {
  playerId: string;
  heroHandle: string;
  abilityHandle: string;
  heroBuildId: string;
}

export interface AbilityChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation UpgradeAbility(
  $playerId: String!
  $heroHandle: String!
  $abilityHandle: String!
  $heroBuildId: String!
) {
  upgradeAbility(
    playerId: $playerId
    heroHandle: $heroHandle
    abilityHandle: $abilityHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationUpgradeAbility(args: MutationUpgradeAbilityArgs) {
  return await graphqlClient.request<AbilityChangeResult>('upgradeAbility', mutation, args);
}
